import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import {WidgetHelperButton} from "../../../basic/widget-helper-button";
import {WidgetHelperButtonEvent} from "../../../basic/widget-helper-button-event";
import {WidgetData} from "../../../widget/widget-data";
import {MvsCoreService} from "../../../service/mvs-core.service";
import {DtoImportObjectContext} from "../../../dto/dto.import.object.context";

@Component({
    selector: 'mvs-crud-object-repo',
    templateUrl: './mvs-crud-object-repo.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MvsCrudObjectRepoComponent
    implements OnInit, OnDestroy, OnChanges {

    @Input() importObjectContextDto: DtoImportObjectContext;

    @Input() objectType: string;
    @Input() objectId: number;


    @Input() formFooterButtons: WidgetHelperButton[];

    @Output() onFooterButtonClick = new EventEmitter<WidgetHelperButtonEvent>();
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    tableWidget: WidgetData;


    constructor(protected coreService: MvsCoreService) {
    }


    ngOnInit(): void {
        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;

        this.tableWidget = new WidgetData();
        this.tableWidget.idAlias = "mvs-crud-repo." + this.objectType;
        this.tableWidget.name = this.objectType;
        this.tableWidget.uiComponent = "table";
        this.tableWidget.dataProvider = "list";
        this.tableWidget.dataSource = "entity";
        this.tableWidget.dataProviderObject = this.objectType;
        this.tableWidget.setParamValue("selectionMode", "single");
        this.tableWidget.setParamValue("size", "S");
    }

    handleButtonClick(event: WidgetHelperButtonEvent) {
        this.onFooterButtonClick.emit(event);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }


}
